import React from "react";
import { Seo } from "../lib/seo";
import { Section, SectionHead, Button, Callout } from "../components/ui";

export default function Demo({ embedded }) {
  return (
    <>
      <Seo title={embedded ? "Chat" : "Live demo"} path={embedded ? "/chat" : "/demo/"} noindex={embedded}
        description="The BloomCONNECT live demo is coming soon. Be an early adopter and secure your slot today." />
      <Section>
        <SectionHead label="Live demo" title="The live demo is coming soon." intro="We're putting the finishing touches on it. In the meantime, secure your place in the early adopter programme." />
        <div className="mt-10 grid gap-8 lg:grid-cols-2 items-start">
          <div className="card-hairline p-8">
            <div className="eyebrow mb-3">Coming soon</div>
            <h2 className="text-2xl text-ink-950">Try the AI live — very soon.</h2>
            <p className="mt-3 text-ink-600 max-w-prose">The interactive demo where you can push back on price, send a voice note and ask for a slot is on its way. Subscribers get first access.</p>
            <div className="mt-6">
              <Button to="/pricing/" variant="primary" size="lg" data-testid="demo-pricing-btn">See plans and pricing</Button>
            </div>
          </div>
          <Callout tone="warning" title="Fair notice">It's good at its job. More than one reviewer admitted it talked them into buying.</Callout>
        </div>
      </Section>
    </>
  );
}
